import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Button } from 'components/Button';

const Nav = styled.header`
  height: ${({ theme }) => theme.headerHeight};

  position: sticky;
  top: ${({ theme }) => theme.settingsBarHeight};
  left: 0;

  z-index: 10;
  background-color: white;
  border-bottom: 0.1rem solid ${pickColor('whiteDark')};
`;

const Wrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaMinWidth.lg(css`
    padding-top: 2rem;
    align-items: flex-start;
  `)};

  height: 100%;
`;

const Ul = styled.ul`
  display: flex;

  height: 100%;
`;

const NavButton = styled(Button)`
  height: 100%;
  white-space: nowrap;
  padding: 0 1.5rem;
  ${mediaMinWidth.lg(css`
    padding: 1rem 1.5rem;
  `)}
`;

const Li = styled.li<{ $fullWidth?: boolean }>`
  position: ${({ $fullWidth }) => ($fullWidth ? 'static' : 'relative')};

  padding: 0;
`;

const SearchButton = styled(Button)`
  margin-left: auto;
  padding: 0 1.5rem;
`;

export { Li, Nav, NavButton, SearchButton, Ul, Wrapper };
